const SERIAL_PROVIDER = {
    'APP_FLYER': 0
};


export {SERIAL_PROVIDER};